window.$ = window.jQuery = require('jquery')
export default function floorNavigation() {
  $(() => {
    $('.h-floor-navigation a').on('click', function (event) {
      event.preventDefault()
      let href = $(event.target).attr('href')
      const speed = 500
      const easing = 'swing'
      const domTarget = $(href === '#' || href === '' ? 'html' : href)
      const scrollTop = domTarget.offset().top
      $('html, body').animate({ scrollTop: scrollTop }, speed, easing)
    })
  });
}
